module.exports = __webpack_public_path__ + "img/logo.0349669c.png";